// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YoutubeOutlinedSvg from "@ant-design/icons-svg/es/asn/YoutubeOutlined";
import AntdIcon from '../components/AntdIcon';

var YoutubeOutlined = function YoutubeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeOutlinedSvg
  }));
};

YoutubeOutlined.displayName = 'YoutubeOutlined';
export default React.forwardRef(YoutubeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/YoutubeOutlined.js
// module id = 2081
// module chunks = 0